import { parseAppDate } from "@/utils/dates/dateFormats";
import { setTimeToMidday, toLocaleTimezone } from "@/utils/dates/dateUtils";
import { HolidayTypeEnum } from "@altertec_gparn/lib";
import { Expose, Transform } from "class-transformer";
import { IsString } from "class-validator";

export class UpdateCollectiveAgreementHolidayDto {
  @IsString()
  id: string;

  @Expose()
  name?: string;

  @Expose()
  type: HolidayTypeEnum;

  @Expose()
  year?: number;

  @Expose()
  description?: string;

  @Expose()
  @Transform(({ value }) => {
    const parsedUtc = parseAppDate(value, false);
    const localDate = toLocaleTimezone(parsedUtc);
    const localMidday = setTimeToMidday(localDate);
    return localMidday.toISOString();
  })
  date?: string;
}
